import { render, staticRenderFns } from "./DetailsCmp.vue?vue&type=template&id=b6296fd0&scoped=true"
import script from "./DetailsCmp.vue?vue&type=script&lang=js"
export * from "./DetailsCmp.vue?vue&type=script&lang=js"
import style0 from "./DetailsCmp.vue?vue&type=style&index=0&id=b6296fd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6296fd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6296fd0')) {
      api.createRecord('b6296fd0', component.options)
    } else {
      api.reload('b6296fd0', component.options)
    }
    module.hot.accept("./DetailsCmp.vue?vue&type=template&id=b6296fd0&scoped=true", function () {
      api.rerender('b6296fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/partition/cmp/DetailsCmp.vue"
export default component.exports